<template>
  <div>
    <el-tabs v-model="editableTabsValue" type="border-card">
      <el-tab-pane name="customer">
        <span slot="label">
          Customer
        </span>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>Order Details - <span v-if="order.id">Customer: <strong>{{order.customer.firstname}} {{order.customer.lastname}}</strong> | Order ID: <strong>{{order.id}}</strong></span></span>
          </div>

          <div class="row" style="margin-bottom:20px;" v-if="!order.id && !newOrderUserId">
            <!-- CREATE NEW -->
            <div class="col-md-12 text-center">
              <button
                class="btn btn-wd btn-default btn-fill btn-move-left btn-lg"
                @click="setOrderType('new')"
              ><span class="btn-label"><i class="ti-plus"></i></span> &nbsp;&nbsp;Create an order for a new customer</button>

              <button
                class="btn btn-wd btn-success btn-fill btn-move-left btn-lg"
                @click="setOrderType('existing')"
              ><span class="btn-label"><i class="ti-user"></i></span> &nbsp;&nbsp;Create an order for an existing customer</button>
            </div>
            
          </div>

          <div class="row" style="margin-bottom:20px;" v-if="!order.id && newOrderUserId && !createdCustomer.id">
            <!-- CREATE NEW -->
            <div class="col-md-12 text-center">
              <h3>Creating order for {{customerData.firstname}} {{customerData.lastname}} ({{customerData.email}})</h3>
              <p>Please select a currency to continue:</p>
            </div>
            
          </div>

          <div class="row" style="margin-bottom:20px;" v-if="!order.id && newOrderUserId && createdCustomer.id">
            <!-- CREATE NEW -->
            <div class="col-md-12 text-center">
              <h2>New customer added successfully!</h2>
              <h3>Creating order for {{customerData.firstname}} {{customerData.lastname}} ({{customerData.email}})</h3>
              <p>Please select a currency to continue:</p>
            </div>
            
          </div>

          <div class="row" style="margin-bottom:20px;" v-if="!order.id && newOrderUserId">
            <!-- CREATE NEW -->
            <div class="col-md-12 text-center">
              <button
                class="btn btn-wd btn-default btn-fill btn-move-right btn-lg"
                @click="setOrderCurrency('TEFLORG')"
              >£ GBP </button>

              <button
                class="btn btn-wd btn-success btn-fill btn-move-right btn-lg"
                @click="setOrderCurrency('TEFLUS')"
              >$ USD </button>

              <button
                class="btn btn-wd btn-warning btn-fill btn-move-right btn-lg"
                @click="setOrderCurrency('IRELAND')"
              >€ EUR </button>
              
              <button
                class="btn btn-wd btn-danger btn-fill btn-move-right btn-lg"
                @click="setOrderCurrency('AUSTRALIA')"
              >A$ AUD </button>

              <button
                class="btn btn-wd btn-primary btn-fill btn-move-right btn-lg"
                @click="setOrderCurrency('CANADA')"
              >CA$ CAD </button>
            </div>
            
          </div>

          <div class="row" style="margin-bottom:20px;">

          <!-- CREATE NEW -->
          <div class="col-md-6 col-md-offset-3" v-if="orderType == 'new'">

            <el-card class="box-card" shadow="never" v-if="!newOrderUserId">
              <div class="card-header">
                <h4 class="title">Add a new customer</h4>
                <p class="category">Enter new customer details below</p>
                <br>
              </div>
              <div class="card-content">
              <el-form :model="customer" :rules="rules" ref="customer" label-width="120px" class>
                <el-form-item label="Title" prop="title">
                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select Title"
                    v-model="customer.title"
                  >
                    <el-option
                      v-for="option in titles"
                      class="select-danger"
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                  <el-input placeholder="Email" v-model="customer.email"></el-input>
                </el-form-item>

                <el-form-item label="Firstname" prop="firstname">
                  <el-input placeholder="Firstname" v-model="customer.firstname"></el-input>
                </el-form-item>

                <el-form-item label="Lastname" prop="lastname">
                  <el-input placeholder="Lastname" v-model="customer.lastname"></el-input>
                </el-form-item>
                <el-form-item label="Phone" prop="phone">
                  <el-input placeholder="Home phone number" v-model="customer.shippingAddress.data.phone"></el-input>
                </el-form-item>

                

                <el-form-item label="Address" prop="shippingAddress.data.line1">
                  <el-input placeholder="Address" v-model="customer.shippingAddress.data.line1"></el-input>
                </el-form-item>
                <el-form-item label prop="shippingAddress.data.line2">
                  <el-input type="text" placeholder="Address " v-model="customer.shippingAddress.data.line2"></el-input>
                </el-form-item>
                <el-form-item label="City/Town" prop="city">
                  <el-input type="text" placeholder="City" v-model="customer.shippingAddress.data.town"></el-input>
                </el-form-item>
                <el-form-item label="Postcode" prop="postalCode">
                  <el-input type="text" placeholder="Postcode" v-model="customer.shippingAddress.data.postcode"></el-input>
                </el-form-item>
                <el-form-item label="Region" prop="region">
                  <el-input type="text" placeholder="Region" v-model="customer.shippingAddress.data.region"></el-input>
                </el-form-item>
                <el-form-item label="Country" prop="shippingAddress.data.country">
                  <el-select
                    value-key="id"
                    class
                    size="small"
                    ref="selectedCountry"
                    style="width:100%"
                    v-model="customer.shippingAddress.data.country"
                    placeholder="Select a country"
                  >
                    <el-option
                    v-for="(country,index) in countries"
                      :value="index"
                      :label="country"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Date of Birth" prop="dob">
                  <el-date-picker
                    v-model="customer.dateOfBirth"
                    type="date"
                    placeholder="Pick a day">
                  </el-date-picker>
                </el-form-item>

                <!--<el-form-item label="Gender" prop="gender">
                  <el-switch v-model="customer.gender" active-text="Male" inactive-text="Female"></el-switch>
                </el-form-item>-->
                <el-form-item label="Marketing" props="acceptsMarketing">
                  <el-switch
                    v-model="customer.acceptsMarketing"
                    active-text="Yes"
                    inactive-text="No"
                  ></el-switch>
                </el-form-item>

                <div class="clearfix"></div>
                <div class="card-footer text-right">
                  <el-button
                    type="primary"
                    v-on:click.prevent="saveCustomer('customer')"
                  >Save Customer</el-button>
                </div>
              </el-form>
              </div>
            </el-card>
          </div>

          <!-- FIND EXISTING CUSTOMER -->
          <div class="col-md-6 col-md-offset-3" v-if="orderType == 'existing' && !newOrderUserId">

            <el-card class="box-card" shadow="never">
              <div class="card-header">
                <h4 class="title">Find existing customer</h4>
                <p class="category">Find a customer using their email below, just begin typing their email to search through our database:</p>
                <br>
              </div>
              <div class="card-content">
                <div class="form-group">
                  <label>Find Customer by Email:</label><br>
                  <el-select
                    v-model="newOrderUserId"
                    filterable
                    remote
                    @change="handleChange"
                    size="large"
                    reserve-keyword
                    placeholder="Please enter a customer email"
                    :remote-method="remoteMethod"
                    :loading="loading"
                  >
                    <el-option
                      v-for="customer in customers"
                      :key="customer.id"
                      :label="customer.email"
                      :value="customer.id"
                    ></el-option>
                  </el-select>
                </div>

              </div>
            </el-card>

          </div>


          <div class="col-md-6 col-md-offset-3 text-center" v-if="order.id">

            <!-- Before order is created -->
            <!--
            <el-card class="box-card" shadow="never" v-if="!order.id && newOrderUserId">
              <div class="card-header">
                <h4 class="title">Create Order</h4>
                <p class="category">Select a currency and create the order:</p>
                <br>
              </div>
              <div class="card-content">
                <div class="form-group">
                  <label>Select the currency:</label><br>
                  <br />
                  <el-select v-model="selectedCurrency" style="width:100%; display: block;">
                    <el-option
                      v-for="currency in currencies"
                      :key="currency.label"
                      :label="currency.label"
                      :value="currency.value"
                    ></el-option>
                  </el-select>
                </div>
                <div class="form-group" v-if="selectedCurrency">
                  <button
                    class="btn btn-lg btn-info pull-left"
                    @click="createOrder(newOrderUserId, selectedCurrency)"
                  >Create Order</button>
                </div>
                <p>&nbsp;<br>&nbsp;</p>
              </div>
            </el-card>
            -->
            
            <!-- After order is created -->

            <h2>Order created!</h2>
            <p class="category">View details below:</p>
            <br>
            <div class="form-group col-md-12">
              <h5>Customer: <strong>{{order.customer.firstname}} {{order.customer.lastname}}</strong></h5> 
              <h5>Order ID: <strong>{{order.id}}</strong></h5>  
            </div>
            <div class="form-group col-md-12">
              <p>To continue please click 'Next'</p>
              <p>If you want to start a new order please click 'Restart'</p>
            </div>

          </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="margin-top:20px">
            <button
              v-if="newOrderUserId"
              class="btn btn-lg btn-danger pull-left"
              @click="restart()"
            >Restart</button>
            <button
              v-if="order.id"
              class="btn btn-wd btn-default btn-fill btn-move-right pull-right btn-lg"
              @click="goToStage2()"
            >Next <span class="btn-label"><i class="ti-angle-right"></i></span></button>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Add Product" name="product">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>Customer Details: <span v-if="order.id"><strong>{{order.customer.firstname}} {{order.customer.lastname}}</strong> | Order ID: <strong>{{order.id}}</strong></span></span>
          </div>

          <div class="col-md-6">
            <el-card v-if="order.id" shadow="never">
              <div class="card-header">
                <h4 class="title">Add products</h4>
                <p class="category">Use the dropdowns below to add products to the order:</p>
                <br>
              </div>
              <div class="card-content">

                <div class="form-group col-md-6">

                <label>Online</label>
                  <br />
                  <el-select v-model="online" placeholder="Select" @change="selectProduct">
                    <el-option
                      v-for="product in onlineCourse"
                      :key="product.id"
                      :label="product.name"
                      :value="product.id"
                    ></el-option>
                  </el-select>

                </div>

                  <div class="form-group col-md-6">
                    <label>Combined</label>
                    <br />
                    <el-select v-model="combined" placeholder="Select" @change="selectClassroom">
                      <el-option
                        v-for="product in combinedCourse"
                        :key="product.id"
                        :label="product.name"
                        :value="product.id"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label>Classroom</label>
                    <br />
                    <el-select v-model="classroom" placeholder="Select" @change="selectClassroom">
                      <el-option
                        v-for="product in classroomCourse"
                        :key="product.id"
                        :label="product.name"
                        :value="product.id"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label>Downloads</label>
                    <br />
                    <el-select v-model="download" placeholder="Select" @change="selectProduct">
                      <el-option
                        v-for="product in downloads"
                        :key="product.id"
                        :label="product.name"
                        :value="product.id"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label>Extras</label>
                    <br />
                    <el-select v-model="extra" placeholder="Select" @change="selectProduct">
                      <el-option
                        v-for="product in extras"
                        :key="product.id"
                        :label="product.name"
                        :value="product.id"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label>Extensions</label>
                    <br />
                    <el-select v-model="extensions" placeholder="Select" @change="selectExtension">
                      <el-option
                        v-for="product in extension"
                        :key="product.id"
                        :label="product.description"
                        :value="product.id"
                      ></el-option>
                    </el-select>
                  </div>
              </div>
              <p><br>&nbsp;<br></p>
            </el-card>

            <el-card v-if="showClassrooms" shadow="never" style="margin-top:20px;">
              <div class="card-header">
                <h4 class="title">Classroom details</h4>
                <p class="category">Looks like there's a classroom course in the order, please select the details below:</p>
                <br>
              </div>
              <div class="card-content">

                  <div class="form-group col-md-6">
                    <label>Location:</label>
                    <br />
                    <el-select value-key="id" v-model="selectedClassroomLocation" placeholder="Select" @change="selectClassroomLocation">
                      <el-option
                        v-for="location in filteredClassroomLocations"
                        :key="location.id"
                        :label="location.venue.town"
                        :value="location"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label>Dates:</label>
                    <br />
                    <el-select v-model="selectedClassroomDate" placeholder="Select" @change="selectClassroomDate">
                      <!-- HARDCODED FLEXIBLE OPTION -->
                      <el-option
                        :key=flexibleId
                        :label="'Flexible - Book now and confirm dates from student dashboard'"
                        :value=flexibleId
                      ></el-option>
                      <el-option
                        v-for="date in classroomDates"
                        :key="date.id"
                        :label="niceDate(date.startDate) + ' - ' + niceDate(date.endDate) +' : ' + date.startTime+' - '+ date.endTime + ' (' + date.numAttendees + '/' + date.maxAttendees + ' spaces taken)'"
                        :value="date.id"
                      ></el-option>
                    </el-select>
                  </div>
              </div>
              <p><br>&nbsp;<br></p>
            </el-card>

            <el-card v-if="showExtensions" shadow="never" style="margin-top:20px;">
              <div class="card-header">
                <h4 class="title">Extension details</h4>
                <p class="category">Looks like there's a extension in the order, please select which product you wish to extend below:</p>
                <br>
              </div>
              <div class="card-content">
                  <div class="form-group col-md-6">
                    <label>Product to extend:</label>
                    <br />
                    <el-select value-key="id" v-model="selectedRelativeBoughtProduct" placeholder="Select" @change="selectRelativeBoughtProduct">
                      <el-option
                        v-for="bp in customerExtensionProducts"
                        :key="bp.id"
                        :label="bp.product.name + '(Expires ' + niceDate(bp.onlineCourseExpiryDate) + ')'"
                        :value="bp.id"
                      ></el-option>
                    </el-select>
                  </div>
              </div>
              <p><br>&nbsp;<br></p>
            </el-card>
 
        
          </div>


          <div class="col-md-6" v-if="order">
            <el-card shadow="never">
              <div class="card-header">
                <h2 class="title">Order Summary</h2>
                <br>
              </div>
              <div class="card-content">
                <div class="form-group">
                  <h4>Customer Details</h4>
                  <strong>First name:</strong> {{order.customer.firstname}}
                  <br />
                  <strong>Last name:</strong> {{order.customer.lastname}}
                  <br />
                </div>
                <div class="form-group">
                  <h4>Products in Order</h4>
                  <el-table :data="order.boughtProducts">
                    <el-table-column label="Product">
                      <template slot-scope="props">{{props.row.product.name}}<br>
                      <span v-if="props.row.classRoom != null && props.row.classRoomId != flexibleId"><strong>Location: </strong>{{props.row.classRoom.venue.town}}<br><strong>Date: </strong>{{props.row.classRoom.startDate | moment('DD MMM YYYY')}} - {{props.row.classRoom.endDate | moment('DD MMM YYYY')}}</span>
                      <span v-if="props.row.classRoom != null && props.row.classRoomId == flexibleId"><strong>Location: </strong>{{props.row.classRoom.venue.town}}<br><strong>Date: </strong>Flexible course selected</span></template>
                    </el-table-column>
                    <el-table-column label="Cost" width="100">
                      <template slot-scope="props">{{props.row.productTotal | priceLabelToSymbol(order.productPriceLabel)}}</template>
                    </el-table-column>
                    <el-table-column label="Remove" width="100">
                      <template slot-scope="props"><button class="btn btn-danger btn-sm" @click="removeProduct(props.row.product.id)">X</button></template>
                    </el-table-column>
                  </el-table>
                <h4 v-if="selectedCurrency"> Order Total: {{order.boughtProductTotalDiscounted | priceLabelToSymbol(order.productPriceLabel)}}</h4>
                </div>
              </div>
            </el-card>
            <el-card shadow="never" v-if="!order.discount" style="margin-top:20px;">
              <div class="card-header">
                <h4 class="title">Discounts</h4>
                <br>
              </div>
              <div class="card-content">
                <div class="form-group" style="padding-bottom:20px;">
                  <div class="col-md-6">
                    <el-input placeholder="Discount Code" v-model="discount"></el-input>
                  </div>
                  <div class="col-md-6">
                    <button
                      class="btn btn-wd btn-default btn-fill btn-move-right pull-left"
                      @click="addDiscount()"
                    >Add discount <span class="btn-label"><i class="ti-angle-right"></i></span></button>
                  </div>
                </div>
              </div>
            </el-card>
            <el-card shadow="never" v-else style="margin-top:20px; padding-bottom:20px;">
              <div class="card-header">
                <h4 class="title">Discounts</h4>
              </div>
              <div class="card-content">
                <div class="form-group" style="padding-bottom:20px;">
                  <p><strong>Discount applied: </strong> {{order.discount.code}}</p>
                  <button
                      class="btn btn-wd btn-danger btn-fill btn-move-left pull-left"
                      @click="removeDiscount()"
                    ><span class="btn-label"><i class="ti-close"></i></span> Remove discount</button>
                </div>
              </div>
            </el-card>
          </div>

          
          <div class="row">
            <div class="col-md-12">
            <p>&nbsp;<br>&nbsp;</p>
            <button
              v-if="order.id"
              class="btn btn-wd btn-danger btn-move-left pull-left btn-lg"
              @click="goToStage1()"
            ><span class="btn-label"><i class="ti-angle-left"></i></span> Back</button>
            <button
              v-if="order.id"
              class="btn btn-wd btn-default btn-fill btn-move-right pull-right btn-lg"
              @click="goToStage3()"
            >Next <span class="btn-label"><i class="ti-angle-right"></i></span></button>
            </div>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="Take Payment" name="payment">

          <el-card class="box-card" shadow="never" style="padding-bottom:20px;">
            <div slot="header" class="clearfix">
              <span>Customer Details: <span v-if="order.id"><strong>{{order.customer.firstname}} {{order.customer.lastname}}</strong> | Order ID: <strong>{{order.id}}</strong></span></span>
            </div>

            <div class="card-content">

              <div class="col-md-6">

                <el-card shadow="never">
                  <div class="card-header">
                    <h2 class="title">Order Summary</h2>
                    <br>
                  </div>
                  <div class="card-content">
                    <div class="row">
                    <div class="form-group col-md-12">
                      <h4>Customer Details</h4>
                        <div class="col-md-6">
                          <h6><strong>Customer:</strong></h6>
                          <strong>First name:</strong> {{customerData.firstname}}
                          <br />
                          <strong>Last name:</strong> {{customerData.lastname}}
                          <br />
                          <strong>Email:</strong> {{customerData.email}}
                          <br /><br />
                        </div>
                        <div class="col-md-6">
                          <h6><strong>Address:</strong></h6>
                          <span v-if="customerData.shippingAddress"> 
                            <strong>Line 1:</strong> {{customerData.shippingAddress.line1}}<br>
                            <strong>Line 2:</strong> {{customerData.shippingAddress.line2}}<br>
                            <strong>Town:</strong> {{customerData.shippingAddress.town}}<br>
                            <strong>Region:</strong> {{customerData.shippingAddress.region}}<br>
                            <strong>Postcode:</strong> {{customerData.shippingAddress.postcode}}
                          </span>
                          <span v-else> 
                            Customer does not have address details on the system.
                          </span>
                          <br /><br />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12">
                        <h4>Products in Order</h4>
                        <el-table :data="order.boughtProducts">
                          <el-table-column label="Product">
                            <template slot-scope="props">{{props.row.product.name}}<br>
                            <span v-if="props.row.classRoom != null && props.row.classRoomId != flexibleId"><strong>Location: </strong>{{props.row.classRoom.venue.town}}<br><strong>Date: </strong>{{props.row.classRoom.startDate | moment('DD MMM YYYY')}} - {{props.row.classRoom.endDate | moment('DD MMM YYYY')}}</span>
                            <span v-if="props.row.classRoom != null && props.row.classRoomId == flexibleId"><strong>Location: </strong>{{props.row.classRoom.venue.town}}<br><strong>Date: </strong>Flexible course selected</span></template>
                          </el-table-column>
                          <el-table-column label="Cost" width="100">
                            <template slot-scope="props">{{props.row.productTotal | priceLabelToSymbol(order.productPriceLabel)}}</template>
                          </el-table-column>
                          <el-table-column label="Remove" width="100">
                            <template slot-scope="props"><button class="btn btn-danger btn-sm" @click="removeProduct(props.row.product.id)">X</button></template>
                          </el-table-column>
                        </el-table>
                        <h4 v-if="selectedCurrency"> Order Total: {{order.boughtProductTotalDiscounted | priceLabelToSymbol(order.productPriceLabel)}}</h4>
                      </div>
                    </div>
                  </div>
                  </el-card>

                  <el-card shadow="never" v-if="!order.discount" style="margin-top:20px;">
                    <div class="card-header">
                      <h4 class="title">Discounts</h4>
                      <br>
                    </div>
                    <div class="card-content">
                      <div class="form-group" style="padding-bottom:20px;">
                        <div class="col-md-6">
                          <el-input placeholder="Discount Code" v-model="discount"></el-input>
                        </div>
                        <div class="col-md-6">
                          <button
                            class="btn btn-wd btn-default btn-fill btn-move-right pull-left"
                            @click="addDiscount()"
                          >Add discount <span class="btn-label"><i class="ti-angle-right"></i></span></button>
                        </div>
                      </div>
                    </div>
                  </el-card>
                  <el-card shadow="never" v-else style="margin-top:20px; padding-bottom:20px;">
                    <div class="card-header">
                      <h4 class="title">Discounts</h4>
                    </div>
                    <div class="card-content">
                      <div class="form-group" style="padding-bottom:20px;">
                        <p><strong>Discount applied: </strong> {{order.discount.code}}</p>
                        <button
                            class="btn btn-wd btn-danger btn-fill btn-move-left pull-left"
                            @click="removeDiscount()"
                          ><span class="btn-label"><i class="ti-close"></i></span> Remove discount</button>
                      </div>
                    </div>
                  </el-card>

              </div>

              <div class="col-md-6" v-if="order">

                <el-card shadow="never">
                  <div class="card-header">
                    <h3>Order confirmation</h3>
                    <br>
                  </div>
                  <div class="card-content">
                    <p><strong>Please check the order details are correct.</strong></p> 
                    <p>Once confirmed you can either:</p>
                    <p>- Click 'Pay Now' to be redirected to the website payment form to complete payment. Use this option to take payments over the phone. Before continuing please ensure you are <strong>logged out</strong> of the website to ensure there are no issues.</p> 
                    <p>- Click 'Generate URL for customer' to show the URL in a textarea for you to paste into an email for the customer, this link will not prefill address details in the payment form. Customers can now complete payment using this link at any time with either Stripe or PayPal.</p>
                    <p>- If you just wish to manually set the order straight to 'Fully Paid' (eg transferring from classroom to virtual) just click 'View Order' and set the status there.</p>
                    <p><em><strong>Note:</strong> Make sure you have completed payment or copied the link before leaving if required. Once this page is closed you will not be able to return.</em></p>
                    <br>
                    <br>
                    <button
                      v-if="order.id"
                      class="btn btn-wd btn-success btn-fill btn-move-right btn-lg"
                      @click="takePayment"
                    >Pay Now <span class="btn-label"><i class="ti-angle-right"></i></span></button>
                    <button
                      v-if="order.id"
                      class="btn btn-wd btn-default btn-fill btn-move-right btn-lg"
                      @click="generateUrl"
                    >Generate URL for customer <span class="btn-label"><i class="ti-angle-right"></i></span></button>
                    <button
                      v-if="order.id"
                      class="btn btn-wd btn-warning btn-fill btn-move-right btn-lg pull-right"
                      @click="goToNewOrder()"
                    >View Order <span class="btn-label"><i class="ti-angle-right"></i></span></button>
                    <br>
                    <br>
                    <el-input type="textarea" rows="3" v-if="showUrl" placeholder="Generated URL" v-model="url"></el-input>
                  </div>
                </el-card>

              </div>
            </div>
          </el-card>


        <p>&nbsp;<br>&nbsp;</p>
        <div class="row">
            <div class="col-md-12" style="margin-top:20px;">
              <button
              v-if="order.id"
              class="btn btn-wd btn-danger btn-move-left pull-left btn-lg"
              @click="goToStage2()"
            ><span class="btn-label"><i class="ti-angle-left"></i></span> Back</button>
              <button
              v-if="order.id"
              class="btn btn-wd btn-success btn-fill btn-move-right pull-right btn-lg"
              @click="takePayment"
            >Pay Now <span class="btn-label"><i class="ti-angle-right"></i></span></button>
            </div>
        </div>


      </el-tab-pane>
    
    </el-tabs>

  </div>
</template>
<script>
import api from "./api";
import customerApi from "../Customers/api";
import serverAPI from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
import json from "../../data/allCountries.json";
  const CREATE_CUSTOMER=gql`
  mutation createCustomer($customer: [Customer_insert_input!]!){
    insert_Customer(objects:$customer){
      returning{
        id

      }
      affected_rows
    }
  }
`;
export default {
  data() {
    return {
      //FLEXIBLE ID - CHANGE THIS IF ID CHANGES IN ADMIN
      flexibleId: 46729,
      titles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      customer: {shippingAddress:{data:{line1:'',line2:'',phone:'',region:'',postcode:'',country:''}}},
      customerData: {shippingAddress:{}},
      countries:  json,
      createdCustomer: {},
      editableTabsValue: "customer",
      online: {},
      combined: {},
      classroom: {},
      extensions: {},
      extra: {},
      download: {},
      order: { customer: {} },
      loading: false,
      newOrderUserId: this.$route.query.customer_id,
      url:"",
      customers: {},
      selectedCurrency: "",
      loadingProducts: false,
      products: [],
      searchItem: {},
      showClassrooms: false,
      showExtensions: false,
      customerOrders: [],
      customerExtensionProducts: [],
      selectedClassroomLocation: "",
      selectedClassroomDate: "",
      selectedRelativeBoughtProduct: "",
      selectedProduct: {},
      selectedBase: "",
      selectedProperty: "",
      selectedValue: "",
      discount: "",
      orderType: "",
      classroomLocations: [],
      filteredClassroomLocations: [],
      classroomDates: [],
      goToOrder: false,
      showUrl: false,
      currencies: [
        {
          value: "TEFLORG",
          label: "GBP"
        },
        {
          value: "TEFLUS",
          label: "USD"
        },
        {
          value: "IRELAND",
          label: "EUR"
        },
        {
          value: "AUSTRALIA",
          label: "AUD"
        },
        {
          value: "CANADA",
          label: "CAD"
        },
      ],
      rules: {
     
        firstname: [
          {
            required: true,
          
            message: "Please input name",
            trigger: "blur"
          }
        ],
        lastname: [
          {
            required: true,
        
            message: "Please input name",
            trigger: "blur"
          }
        ],
        line1: [
          { required: true, message: "Please add address", trigger: "change" }
        ],
        town: [
          { required: true, message: "Please add town", trigger: "change" }
        ],
        country: [
          { required: true, message: "Please add country", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please input correct email address",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    // this.editableTabsValue='product';
    this.getProducts();
    if(this.newOrderUserId){
    this.getCustomer(this.newOrderUserId);
    }
  },
  methods: {
    setBase(term) {
      this.searchItem = this.searchProperty[this.selectedBase];
    },
    niceDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    setOrderCurrency(currency){
      this.selectedCurrency = currency;
      this.createOrder(this.newOrderUserId, this.selectedCurrency);
    },
    setOrderType(orderType){
      this.orderType = orderType;
    },
    handleChange(tab, event) {
      console.log(tab);
      this.getCustomer(this.newOrderUserId);
      // var tempCust = tab[0].split(":");
      //console.log(tempCust)
      //this.order.mainUser.name = tempCust[0];
      // this.order.mainUser.id = tempCust[1];
    },
    restart(){
      this.order = { customer: {} };
      this.newOrderUserId = ""
      this.selectedCurrency = ""
      this.createdCustomer = {}
      this.customerData = {shippingAddress:{}}
    },
    goToStage1(){
      this.editableTabsValue = "customer"
    },
    goToStage2(){
      this.editableTabsValue = "product"
    },
    goToStage3(){
      this.editableTabsValue = "payment"
      //console.log('Customer: ',this.customerData)
    },
    saveCustomer(formName) {
      this.customer.username = this.customer.email;
      this.customer.dateCreated = moment().format()
      const customer = this.customer && this.customer
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$apollo.mutate({
            mutation:CREATE_CUSTOMER,
            variables:{
              customer:customer
            }
          }).then(result => {
            this.$notify({
              title: "Success",
              message: "Customer Created",
              type: "success"
            });
            this.createdCustomer = result.data.insert_Customer.returning[0];
            this.newOrderUserId = result.data.insert_Customer.returning[0].id;
            this.getCustomer(this.newOrderUserId);
          }).catch(error => {
              this.$notify({
                title: "Error",
                message: error.message,
                type: "error"
              });
          });
        }
      })
    },
    selectProduct(product){
      api
        .addProduct({ order_id: this.order.id, product_id: product })
        .then(response => {
          console.log("response", response);
          this.order = response;
      });
    },
    selectClassroom(product){
      this.showClassrooms = true;
      this.selectedProduct = this.products.find( ({ id }) => id === product );
      const days = this.selectedProduct.classRoomCourse.days;
      api.getLocationsByDays(days)
      .then(response => {
          console.log('Classrooms: ', response.data);
          response.data.sort((a,b) => (a.venue.town > b.venue.town) ? 1 : ((b.venue.town > a.venue.town) ? -1 : 0));
          this.classroomLocations = response.data;
          this.classroomDates = response.data;
          //var filteredClassroomLocations = [] 
          this.filteredClassroomLocations = response.data.filter((e, i) => {
            return response.data.findIndex((x) => {
              return x.venue.town == e.venue.town
            }) == i;
          }); 
          console.log('Filtered Classrooms: ', this.filteredClassroomLocations);
          console.log('All Classrooms: ', this.classroomLocations);
          //this.classroomDates = response.data;
      })
    },

    selectExtension(product){
      this.showExtensions = true;
      this.selectedProduct = this.products.find( ({ id }) => id === product );
      this.getOrders(this.newOrderUserId);
    },

    getOrders(id) {
      this.$apollo
        .query({
          query: gql`{
            Order(where: { _and: {customerId: {_eq: "${id}"}, status: {_neq: "0"}}}) {
            id
            customerId
            boughtProducts {
              id
              product {
                id
                course {
                  type
                  id
                  hours
                }
                description
                isPublic
                name
                onlineCourse {
                  id
                }
                type
              }
              certSent
              certUrl
              onlineCoursePassed
              relativeOrderBoughtProductId
              onlineCourseExpiryDate
            }
          }
        }`
        })
        .then(response => {
          //console.log('customerOrders: ',response.data.Order);
          this.customerOrders = response.data.Order;
          this.customerExtensionProducts = [];
          for (var i = 0; i < this.customerOrders.length; i++) {
            for (var j = 0; j < this.customerOrders[i].boughtProducts.length; j++) {
              if (this.customerOrders[i].boughtProducts[j].product.type == 'online course' || this.customerOrders[i].boughtProducts[j].product.type == 'combined course') {
                  this.customerExtensionProducts.push(this.customerOrders[i].boughtProducts[j]);
              }
            }
          }
          console.log('customerExtensionProducts: ',this.customerExtensionProducts);
        });
    },

    selectClassroomLocation(location){
      this.classroomDates = this.classroomLocations.filter(loc => loc.venue.town === location.venue.town)
      this.classroomDates = this.classroomDates.filter(date => date.numAttendees < date.maxAttendees)

      console.log('Dates: ', this.classroomDates);
    },
    selectClassroomDate(classroom){
      api
        .addProduct({ order_id: this.order.id, product_id: this.selectedProduct.id, classroom_id: classroom})
        .then(response => {
          console.log("response", response);
          this.order = response;
      });
    },
    selectRelativeBoughtProduct(id){
      api
        .addProduct({ order_id: this.order.id, product_id: this.selectedProduct.id, relative_order_bought_product_id: id})
        .then(response => {
          console.log("response", response);
          this.order = response;
      });
    },
    createOrder(newOrderUserId, selectedCurrency) {
      api
        .createOrder({ userId: newOrderUserId, currency: selectedCurrency })
        .then(response => {
          this.$notify({
              title: "Success",
              message: "Order Created",
              type: "success"
            });
          console.log("response", response);
          this.order = response;
          this.goToStage2();
        })
        .catch(error => {
            this.$notify({
              title: "Error",
              message: error.message,
              type: "error"
            });
        });
    },
    getCustomers(prop) {
      this.$apollo
        .query({
          query: gql`{
              Customer(where: {email: {_ilike: "%${prop}%"}, _or: {username: {_ilike: "%${prop}%"}}}) {
                id
                firstname
                lastname
                email
              }
            }`
        })
        .then(response => {
          this.customers = response.data.Customer;
          this.loadingCustomers = false;
        });
    },
    getCustomer(id) {
      this.$apollo
        .query({
          query: gql`{
              Customer(where: {id: {_eq: "${id}"}}) {
                id
                firstname
                lastname
                email
                shippingAddress {
                  id
                  line1
                  line2
                  phone
                  postcode
                  region
                  town
                  country
                }
              }
            }`
        })
        .then(response => {
          console.log('customerData: ',response.data.Customer[0]);
          this.customerData = response.data.Customer[0];
        });
    },

    getProducts() {
      this.loadingProducts = true;
      this.$apollo
        .query({
          query: gql`
            {
              Product(order_by: { name: asc }) {
                name
                description
                id
                type
                isPublic
                prices(where: { dateTo: { _eq: "2090-01-01" } }) {
                  cost
                }
                classRoomCourse {
                  days
                }
              }
            }
          `,
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          this.products = response.data.Product;
          this.loadingProducts = false;
        });
    },

    addProduct() {
      console.log(b)
      this.selectedValue = online;
    },
    addDiscount() {
      api
        .addDiscount({ order_id: this.order.id, discount_code: this.discount })
        .then(response => {
          console.log("response", response);
          this.order.boughtProductTotalDiscounted = response.boughtProductTotalDiscounted;
          this.order.discount = response.discount;
      });
    },
    removeDiscount() {
      api
        .removeDiscount({ order_id: this.order.id })
        .then(response => {
          console.log("response", response);
          this.order.boughtProductTotalDiscounted = response.boughtProductTotalDiscounted;
          this.order.discount = response.discount;
      });
    },
    takePayment(){
      let currency = this.currencies.find(c => c.value==this.selectedCurrency)
      if (this.customerData.shippingAddress) {
        var town = this.customerData.shippingAddress.town != null ? this.customerData.shippingAddress.town : this.customerData.shippingAddress.city
        this.url="https://www.tefl.org/checkout/manual/?payment_type=manual_payment&firstname="+this.order.customer.firstname+"&surname="+this.order.customer.lastname+"&order_id="+this.order.id+"&transactionamount="+this.order.boughtProductTotalDiscounted+"&currency="+currency.label+"&email="+this.customerData.email+"&line1="+this.customerData.shippingAddress.line1+"&line2="+this.customerData.shippingAddress.line2+"&town="+town+"&region="+this.customerData.shippingAddress.region+"&postcode="+this.customerData.shippingAddress.postcode+"&country="+this.customerData.shippingAddress.country;
      } else  {
        this.url="https://www.tefl.org/checkout/manual/?payment_type=manual_payment&firstname="+this.order.customer.firstname+"&surname="+this.order.customer.lastname+"&order_id="+this.order.id+"&transactionamount="+this.order.boughtProductTotalDiscounted+"&currency="+currency.label+"&email="+this.customerData.email;
      }
      console.log(this.url)
      window.open(this.url)
      this.goToOrder = true
    },
    generateUrl(){
      let currency = this.currencies.find(c => c.value==this.selectedCurrency)
      if(this.customerData.shippingAddress) {
        this.url="https://www.tefl.org/checkout/manual/?payment_type=manual_payment&firstname="+this.order.customer.firstname+"&surname="+this.order.customer.lastname+"&order_id="+this.order.id+"&transactionamount="+this.order.boughtProductTotalDiscounted+"&currency="+currency.label+"&email="+this.customerData.email+"&country="+this.customerData.shippingAddress.country;
      } else {
        this.url="https://www.tefl.org/checkout/manual/?payment_type=manual_payment&firstname="+this.order.customer.firstname+"&surname="+this.order.customer.lastname+"&order_id="+this.order.id+"&transactionamount="+this.order.boughtProductTotalDiscounted+"&currency="+currency.label+"&email="+this.customerData.email;
      }
      console.log(this.url)
      //window.open(this.url)
      this.showUrl = true
      this.goToOrder = true
    },
    goToNewOrder(){
      //this.$router.push({ path: "/order/edit/" + this.order.id })
      //this.$router.resolve({name: 'routeName', query: {data: "someData"}});
      //Hopefully this will open in a new tab
      let route = this.$router.resolve({ path: "/order/edit/" + this.order.id });
      window.open(route.href, '_blank');
    },
    removeProduct(product) {
      api
        .removeProduct({ order_id: this.order.id, product_id: product })
        .then(response => {
          console.log("response", response);
          this.order = response;
        });
    },
    remoteMethod(query) {
      if (query !== "" && query.length > 2) {
        this.getCustomers(query);
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      } else {
        this.customers = {};
      }
    }
  },

  computed: {
    onlineCourse: function() {
      return this.products.filter(function(online) {
        return online.type === "online course";
      });
    },

    combinedCourse: function() {
      return this.products.filter(function(combined) {
        return combined.type === "combined course";
      });
    },

    classroomCourse: function() {
      return this.products.filter(function(classroom) {
        return classroom.type === "classroom course";
      });
    },

    downloads: function() {
      return this.products.filter(function(downloads) {
        return downloads.type === "download";
      });
    },

    extras: function() {
      return this.products.filter(function(extras) {
        return extras.type === "extras";
      });
    },

    extension: function() {
      return this.products.filter(function(extension) {
        return extension.type === "online extension" && extension.name.substr(extension.name.length - 6) == "expiry";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Orders/Create.vue